if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        /* Sümer (24.10): dokunuş hiçbir durumda sessizce kaybolmaz.
           - Basınca hemen "Ekleniyor…" + kilit (çift dokunuş / sabit çubuk + ana düğme tek istek).
           - Varyant değişimi sürerken (Dawn yeni varyantı sunucudan alırken) dokunuş bekletilir,
             yeni varyant gelince gönderilir (eskiden düğme disabled olduğu için dokunuş yutuluyordu).
           - İstek 5 sn'de cevap vermezse sepet okunur: eklenmişse yeniden denenmez; eklenmemişse bir kez
             daha denenir; yine olmazsa "Eklenemedi, tekrar deneyin". Geç cevap veren ilk istek yüzünden
             miktar fazla çıkarsa tek eklemeye düzeltilir (aynı ürün iki kez eklenmez). */
        this.kilitli = false;
        this.varyantBekliyor = false;
        this.bekleyenGonderim = false;
      }

      kilitle() {
        this.kilitli = true;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('sumer-ekleniyor');
        if (this.submitButtonText) this.submitButtonText.textContent = 'Ekleniyor…';
        this.handleErrorMessage();
      }

      kilidiAc(metin) {
        this.kilitli = false;
        this.submitButton.classList.remove('sumer-ekleniyor', 'loading');
        this.querySelector('.loading__spinner')?.classList.add('hidden');
        this.submitButton.removeAttribute('aria-disabled');
        if (this.submitButtonText) this.submitButtonText.textContent = metin || window.variantStrings.addToCart;
      }

      eklenemedi() {
        const metin = 'Eklenemedi, tekrar deneyin';
        this.kilidiAc(metin);
        this.handleErrorMessage(metin);
        clearTimeout(this.hataZamani);
        this.hataZamani = setTimeout(() => {
          if (!this.kilitli && this.submitButtonText && this.submitButtonText.textContent === metin)
            this.submitButtonText.textContent = window.variantStrings.addToCart;
        }, 4000);
      }

      /* Varyant değişti, yeni varyant sunucudan bekleniyor (product-info.js → resetProductFormState).
         Düğme dokunuşu kabul eder; gönderim yeni varyant gelene kadar bekletilir. */
      beklemeyeAl() {
        this.varyantBekliyor = true;
        this.handleErrorMessage();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.kilitli) return;
        if (this.submitButton.hasAttribute('disabled')) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.kilitle();
        if (this.varyantBekliyor) {
          this.bekleyenGonderim = true;
          clearTimeout(this.bekleZamani);
          this.bekleZamani = setTimeout(() => {
            if (!this.bekleyenGonderim) return;
            this.bekleyenGonderim = false;
            this.eklenemedi();
          }, 8000);
          return;
        }
        this.gonder(evt);
      }

      sepetMiktari(variantId) {
        const ac = new AbortController();
        const z = setTimeout(() => ac.abort(), 2500);
        return fetch(`${routes.cart_url}.js`, { cache: 'no-store', headers: { Accept: 'application/json' }, signal: ac.signal })
          .then((r) => (r.ok ? r.json() : null))
          .then((c) => (c ? c.items.filter((i) => String(i.variant_id) === String(variantId)).reduce((t, i) => t + i.quantity, 0) : null))
          .catch(() => null)
          .finally(() => clearTimeout(z));
      }

      ekleIstegi(formData, ms) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;
        /* Sümer (25.10): istek KESİLMEZ (abort yok), yalnız beklemesi ms ile sınırlanır. Geç de olsa cevap gelirse
           Shopify'ın product_added_to_cart olayı (Meta AddToCart / GA4 add_to_cart) yine oluşur; kesilen istekte
           ürün sunucuda sepete girse bile olay oluşmuyordu. */
        const istek = fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .catch(() => null);   // ağ hatası
        let z;
        const zaman = new Promise((res) => { z = setTimeout(() => res(null), ms); });   // zaman aşımı
        return Promise.race([istek, zaman]).finally(() => clearTimeout(z));
      }

      /* Zaman aşımından sonra ürünün aslında eklendiği anlaşılırsa: çekmece için bölümler ayrıca okunur */
      eklenmisYanit(variantId) {
        if (!this.cart) return Promise.resolve({ id: Number(variantId) });
        const ids = this.cart.getSectionsToRender().map((section) => section.id).join(',');
        return fetch(`${window.location.pathname}?sections=${encodeURIComponent(ids)}`, { cache: 'no-store' })
          .then((r) => (r.ok ? r.json() : {}))
          .catch(() => ({}))
          .then((sections) => ({ id: Number(variantId), sections }));
      }

      /* Fazla eklenen miktarı tek eklemeye indir (ilk istek geç işlenirse) */
      fazlayiDuzelt(variantId, hedef) {
        return fetch(`${routes.cart_url}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : null))
          .then((c) => {
            const satir = c && c.items.find((i) => String(i.variant_id) === String(variantId));
            if (!satir || satir.quantity <= hedef) return;
            const config = fetchConfig('json');
            config.body = JSON.stringify({ id: satir.key, quantity: hedef });
            return fetch(`${routes.cart_change_url}`, config)
              .then((r) => r.json())
              .then((cart) => publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sumer-tekillestir', productVariantId: variantId, cartData: cart }));
          })
          .catch(() => {});
      }

      async gonder(evt) {
        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const once = await this.sepetMiktari(variantId);
        let response = await this.ekleIstegi(formData, 5000);
        let tekrarDenendi = false;
        if (!response) {
          const sonra = await this.sepetMiktari(variantId);
          if (sonra !== null && sonra > (once ?? 0)) response = await this.eklenmisYanit(variantId);
          else {
            tekrarDenendi = true;
            response = await this.ekleIstegi(formData, 5000);
            if (!response) {
              const son = await this.sepetMiktari(variantId);
              if (son !== null && son > (once ?? 0)) response = await this.eklenmisYanit(variantId);
            }
          }
        }
        if (!response) { this.eklenemedi(); return; }
        if (tekrarDenendi && once !== null && !response.status) {
          this.fazlayiDuzelt(variantId, once + 1);
          setTimeout(() => this.fazlayiDuzelt(variantId, once + 1), 6000);
        }
        this.isle(response, formData, evt);
      }

      isle(response, formData, evt) {
        Promise.resolve(response)
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.kilitli = false;
            this.submitButton.classList.remove('sumer-ekleniyor');
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
              if (this.submitButtonText && this.submitButtonText.textContent === 'Ekleniyor…')
                this.submitButtonText.textContent = window.variantStrings.addToCart;
            }
            this.querySelector('.loading__spinner').classList.add('hidden');

            if (evt) CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.varyantBekliyor = false;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
        /* Varyant beklenirken basılmıştı: yeni varyant geldi */
        if (this.bekleyenGonderim) {
          clearTimeout(this.bekleZamani);
          this.bekleyenGonderim = false;
          if (disable) {   // yeni seçim tükendi / mevcut değil: eklenmez, düğme o durumu gösterir
            this.kilitli = false;
            this.submitButton.classList.remove('sumer-ekleniyor');
            this.submitButton.removeAttribute('aria-disabled');
          } else {
            this.submitButtonText.textContent = 'Ekleniyor…';
            this.gonder();
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
